import clsx from "clsx";
import type {
  VisualDiffStatusCounts,
  VisualDiffTypeEntry,
} from "../../utils/computeVisualDiff";

export const buildCountSegments = (
  counts: VisualDiffStatusCounts,
  translate: (key: string, options: { count: number }) => string,
): string[] => {
  const segments: string[] = [];
  if (counts.addedCount > 0) {
    segments.push(
      translate("smartSurveyor.planComparison.quantities.addedCount", {
        count: counts.addedCount,
      }),
    );
  }
  if (counts.removedCount > 0) {
    segments.push(
      translate("smartSurveyor.planComparison.quantities.removedCount", {
        count: counts.removedCount,
      }),
    );
  }
  if (counts.changedCount > 0) {
    segments.push(
      translate("smartSurveyor.planComparison.quantities.changedCount", {
        count: counts.changedCount,
      }),
    );
  }
  // Only worth saying when there is nothing else to say — otherwise it drowns the changes.
  if (segments.length === 0 && counts.unchangedCount > 0) {
    segments.push(
      translate("smartSurveyor.planComparison.quantities.unchangedCount", {
        count: counts.unchangedCount,
      }),
    );
  }
  return segments;
};

export const sumEntryCounts = (
  entries: VisualDiffTypeEntry[],
): VisualDiffStatusCounts => {
  const totals: VisualDiffStatusCounts = {
    addedCount: 0,
    removedCount: 0,
    changedCount: 0,
    unchangedCount: 0,
  };
  for (const entry of entries) {
    totals.addedCount += entry.addedCount;
    totals.removedCount += entry.removedCount;
    totals.changedCount += entry.changedCount;
    totals.unchangedCount += entry.unchangedCount;
  }
  return totals;
};

export const buildRailRowClass = (isSelected: boolean): string =>
  clsx(
    "w-full rounded-lg px-2 py-1.5 text-left transition-colors",
    isSelected
      ? "bg-blue-50 ring-1 ring-inset ring-blue-200"
      : "hover:bg-gray-50",
  );
